module.exports = __webpack_public_path__ + "img/extensao-zip.4dbe7a90.png";